import { useCallback } from "react";
import { FieldValues, UseFormClearErrors, useFormContext } from "react-hook-form";

import { useRequestFormReviewValidation } from "@RequestFormV2/context/reviewValidation";

/**
 * Routes field clears through `clearFieldError` after Review so accordion
 * section badges stay in sync; uses plain `clearErrors` before Review.
 */
export function useSyncedClearErrors() {
  const { clearErrors } = useFormContext();
  const { hasAttemptedReview, clearFieldError } = useRequestFormReviewValidation();

  return useCallback<UseFormClearErrors<FieldValues>>(
    (name) => {
      if (hasAttemptedReview && clearFieldError && typeof name === "string") {
        clearFieldError(name);
      } else {
        clearErrors(name);
      }
    },
    [hasAttemptedReview, clearFieldError, clearErrors],
  );
}
